import axios from "@/libs/api.request";
// 获取应收报表列表
export const getLocation = data => {
  return axios.request({
    url: "/finance/hq/kw/detail/index",
    method: "post",
    data
  });
};

export const getSku = params => {
  return axios.request({
    url: "/report/stock/sku",
    method: "get",
    params
  });
};

// 生成账单
export const createBill = data => {
  return axios.request({
    url: "/finance/hq/kw/detail/createBill",
    method: "post",
    data
  });
};

export const uploadFixedStock = data => {
  return axios.request({
    url: "/report/stock/uploadFixedStock",
    method: "post",
    data
  });
};

export const exportCustomerData = data  => {
  return axios.request({
    url: "/report/stock/exportCustomerData",
    method: "post",
    data
  });
};
